module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD5SURBVHgBrVPLEQFBEH29BOLohgDkQASIADfWgRNHZEAENgMyQAZCEIH2ZvZT1s7WmiqvamZ6evp1T9e8EZQh1CUEE2u/cMBGpq4wye3m2qOnTavF0cudKSKe3Wk9sJZDMUGoV85t/IYbk3SMESTkoQcZNtbcNksANOCLuNUsQQu+0JhTw0K3XIcV4SOOJz7bFDTRXUngJCuOObLQ4y4yrsONM9/+Yhs0ZKUOShDwcF/wCgmGWEFmkWOsg1BP+BZONSJqoZ++wh3+sJw4gVJZvnhR0viDlPOfaUZJB1aVxc9kejbXNrfdSJQ6pbRGqDvOg2S3Z8WVK+wNnKhDqa4DV9AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/offline-mode.png
// module id = r8Wo
// module chunks = 46